module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAD1BMVEXOESb////YQVHroKjicH3jnv4CAAAA00lEQVR4Xr3XsRUDMQgEUUpgQQVQgkpQ/1U5sXNPwJJPwJP+u1PoO/H/6DfJExVPdHgiPZ7o8kTJE4kn0vBEDyeNdzl4l8LrT9AEn34HTW7Q5GEvQ4kVh6xrsi+eSGOyf3iidtlPnqgM9i+2//btF7af+/YbeznhsH94onbZT56oDPbhTeZe/PZz334bzqUM3xeDl2uzb/iHka7Jvngijcn+4YnaYn+w/di3fw0vvtl/vabBvoInGpP9wxO1y37yRGWyr+dIZn/93LffhmvJ7c8i5A+H6mEMno660QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Bahrain.png
// module id = 559
// module chunks = 0